const rankings = [
  {
    rank: 1,
    title: '台北娜娜最新视频全解析',
    tag: '台北娜娜',
    hot: '128万热度',
    change: 'up',
  },
  {
    rank: 2,
    title: '玩偶姐姐身份深度挖掘专题',
    tag: '玩偶姐姐',
    hot: '96万热度',
    change: 'up',
  },
  {
    rank: 3,
    title: '莫里秀历年合集大盘点',
    tag: '莫里秀',
    hot: '87万热度',
    change: 'down',
  },
  {
    rank: 4,
    title: '娱乐圈最新连环爆料追踪',
    tag: '娱乐圈',
    hot: '65万热度',
    change: 'up',
  },
  {
    rank: 5,
    title: '台北娜娜闺蜜圈关系网图解',
    tag: '台北娜娜',
    hot: '54万热度',
    change: 'new',
  },
  {
    rank: 6,
    title: '2025上半年吃瓜大事件回顾',
    tag: '年度盘点',
    hot: '43万热度',
    change: 'down',
  },
  {
    rank: 7,
    title: '51吃瓜app独家内幕专区精选',
    tag: '独家',
    hot: '38万热度',
    change: 'up',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            吃瓜排行榜
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            实时热度榜单，看看今天大家都在关注什么
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl overflow-hidden">
          {rankings.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer transition-colors hover:bg-background-200/50 ${
                i < rankings.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-accent-500 text-white'
                    : item.rank === 2
                      ? 'bg-accent-300 text-accent-900'
                      : item.rank === 3
                        ? 'bg-accent-200 text-accent-800'
                        : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5 flex-wrap">
                  <span className="px-1.5 py-0.5 text-[10px] rounded-full bg-secondary-100 text-secondary-700 font-medium">
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm font-medium text-foreground-800 truncate">
                  {item.title}
                </p>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.hot}</span>
                <span
                  className={`w-5 h-5 flex items-center justify-center ${
                    item.change === 'up'
                      ? 'text-primary-500'
                      : item.change === 'down'
                        ? 'text-secondary-500'
                        : 'text-accent-500'
                  }`}
                >
                  {item.change === 'up' && <i className="ri-arrow-up-line"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line"></i>}
                  {item.change === 'new' && <i className="ri-arrow-up-circle-line"></i>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}